<template>
    <div class="home page">
        <wrapper column :backgroundImage="background" scrollable>
            <div class="image-container">
                <img src="@/assets/Home/top.png" alt="" width="100%" />
            </div>
            <Layout
                :on-click="goToRoute"
                @open="groupPopupState = true"
                @changeName="formPopupState = true"
                @leave-event="leaveEvent"
                @join-event="eventPopupState = true"
            />
            <div class="footer image-container">
                <img src="@/assets/Home/footer.png" alt="" width="100%" />
                <div class="code">
                    <div>TW22DI00105</div>
                    <div>2022/12</div>
                </div>
            </div>
        </wrapper>
        <transition name="fade" mode="out-in">
            <Profile v-if="formPopupState" @close="formPopupState = false" />
        </transition>
        <transition name="fade" mode="out-in">
            <Group v-if="groupPopupState" @close="groupPopupState = false" />
        </transition>
        <transition name="fade" mode="out-in">
            <Event
                v-if="eventPopupState"
                @close="cancelQuickJoinEvent"
                :eventId="quickJoinEventId"
            />
        </transition>
        <transition name="fade" mode="out-in">
            <AlertWrapper
                v-if="eventExpiredState"
                @close="leaveEvent"
                title="活動已過期"
                content="我們將自動為你退出活動"
            />
        </transition>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import liff from '@line/liff';
import moment from 'moment';
import PageGeneral from '@/mixins/PageGeneral';
import Layout from '@/components/Home/Layout.vue';
import Profile from '@/components/Home/Profile.vue';
import Group from '@/components/Home/Group.vue';
import Event from '@/components/Home/Event.vue';
import AlertWrapper from '@/components/Wrapper/AlertWrapper.vue';
import Sdk from '@/sdk';

export default {
    props: ['isReady'],
    mixins: [PageGeneral],
    components: {
        Layout, Profile, Group, Event, AlertWrapper,
    },
    data() {
        return {
            groupPopupState: false,
            formPopupState: false,
            eventPopupState: false,
            eventExpiredState: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
            loginDayCount: (state) => state.loginDayCount,
        }),
        quickJoinEventId() {
            return this.$route.params.eventId;
        },
    },
    methods: {
        ...mapActions(['emptyNameHotUpdate']),
        async checkEventExpired() {
            if (this.isReady && this.user?.event?.endDate) {
                if (moment() > moment(this.user.event.endDate)) {
                    this.eventExpiredState = true;
                }
            }
        },
        async handleQuickJoinEvent() {
            if (!this.quickJoinEventId) return;
            liff.ready.then(() => {
                if (liff.isLoggedIn()) {
                    this.eventPopupState = true;
                } else {
                    liff.login({
                        redirectUri: window.location.href,
                    });
                }
            });
        },
        cancelQuickJoinEvent() {
            this.eventPopupState = false;
            if (this.quickJoinEventId) this.$router.replace({ name: 'Home' });
        },
        async leaveEvent() {
            try {
                await Sdk.leaveEvent();
                this.eventExpiredState = false;
            } catch ({ response }) {
                alert(response.data.message);
            }
        },
    },
    created() {
        this.handleQuickJoinEvent();
    },
    watch: {
        user(user) {
            if (_.isEmpty(user.name)) {
                if (!user.lastLogin) this.formPopupState = true;
                else {
                    // 截至 20220413, 有許多玩家因為bug沒有輸入到名字
                    // 當發現空名字時，登入後更新line名稱
                    this.emptyNameHotUpdate();
                }
            }
            this.checkEventExpired();
        },
        isReady(ready) {
            if (ready) this.checkEventExpired();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../scss/main.scss";
.code {
    margin-top: -54px;
    padding: 10px 20px;
    font-size: 12px;
}
</style>
